import { render, staticRenderFns } from "./Treasurer.vue?vue&type=template&id=1f5caeed&scoped=true&"
import script from "./Treasurer.vue?vue&type=script&lang=js&"
export * from "./Treasurer.vue?vue&type=script&lang=js&"
import style0 from "./Treasurer.vue?vue&type=style&index=0&id=1f5caeed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5caeed",
  null
  
)

export default component.exports